import { Date as ParseDate } from "prismic-reactjs"

const formatDate = (value) =>
  Intl.DateTimeFormat("en-US", {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric",
  }).format(ParseDate(value))

const formatTime = (value, hideTimeZone = false) => {
  let options = {
    hour: "numeric",
    minute: "numeric",
  }
  if (!hideTimeZone) {
    options = {
      ...options,
      timeZone: "Asia/Calcutta",
      timeZoneName: "long",
    }
  }
  return Intl.DateTimeFormat("en-US", options).format(ParseDate(value))
}

export { formatTime, formatDate }
